/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route__badge__discovery = /** @type {(inputs: {}) => string} */ () => {
	return `Entdeckung`
};

const en_route__badge__discovery = /** @type {(inputs: {}) => string} */ () => {
	return `Discovery`
};

const es_route__badge__discovery = /** @type {(inputs: {}) => string} */ () => {
	return `Descubra`
};

const fr_route__badge__discovery = /** @type {(inputs: {}) => string} */ () => {
	return `Découverte`
};

const it_route__badge__discovery = /** @type {(inputs: {}) => string} */ () => {
	return `Scoprire`
};

const nl_route__badge__discovery = /** @type {(inputs: {}) => string} */ () => {
	return `Ontdek`
};

const pt_route__badge__discovery = /** @type {(inputs: {}) => string} */ () => {
	return `Descobrir`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__discovery = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route__badge__discovery(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route__badge__discovery", locale)
	if (locale === "de") return de_route__badge__discovery(inputs)
	if (locale === "en") return en_route__badge__discovery(inputs)
	if (locale === "es") return es_route__badge__discovery(inputs)
	if (locale === "fr") return fr_route__badge__discovery(inputs)
	if (locale === "it") return it_route__badge__discovery(inputs)
	if (locale === "nl") return nl_route__badge__discovery(inputs)
	return pt_route__badge__discovery(inputs)
};